class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");

    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (parsedState.items) {
      /* if multiple items added to cart */
      this.cartItemKey = "undefined";
    } else {
      this.cartItemKey = parsedState.key;
    }

    this.getSectionsToRender().forEach((section) => {
      if (parsedState.items && section.id == "cart-notification-product") {
        document.getElementById(section.id).innerHTML = "";
      } else {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
      }
    });

    if (this.header) this.header.reveal();
    this.open();

    /* custom START
     * Displays custom product recocommendations/upsell popup on selected products
     */
    /*
      const buttonEl = document.getElementById('ProductRecoTriggerPopup');
      if (typeof(buttonEl) != 'undefined' && buttonEl != null) {
        setTimeout(() => {
          buttonEl.click();
        }, 1000);
      }
      */

    /* Show free shipping and gift notifications upon adding product to cart */
    const fsTextContainer = document.getElementById("notifShippingText");
    if (typeof fsTextContainer != "undefined" && fsTextContainer) {
      updateFreePromoMessage.displayNotification(fsTextContainer, "shipping");
    }
    const fgTextContainer = document.getElementById("notifGiftText");
    if (typeof fgTextContainer != "undefined" && fgTextContainer) {
      updateFreePromoMessage.displayNotification(fgTextContainer, "gift");
    }
    /* END */
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
